
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CancelConfirm',
    props: {
        periodEndLabel: { type: String, default: '' },
    },
    emits: ['next', 'stay'],
});
